import { InputNumber } from "primereact/inputnumber";
import styles from "./index.module.scss";
import { InputProps } from "./input.interface";

export const NumberInput = ({
  label,
  type,
  onChange,
  value,
  size,
  className,
  name,
  placeholder,
  maxLength,
  onBlur,
  tabIndex,
  autoFocus,
  onKeyDown,
  touched,
  isError,
  errorMessage,
  required,
  searchIcon,
  disabled
}: InputProps) => {
  return (
    <div className={`${styles.inputBox} ${className}`}>
      {label ? (
        <label htmlFor={label}>
          {label}
          {required ? <span className={styles.reqText}>*</span> : ""}
        </label>
      ) : (
        ""
      )}

      {/* <div className='p-input-icon-left'> */}
      <InputNumber
        disabled={disabled}
        maxLength={maxLength}
        className={[styles[`${type}`], styles[`${size}`], className].join(" ")}
        type={type}
        onChange={onChange}
        placeholder={placeholder}
        value={value}
        onBlur={onBlur}
        name={name}
        tabIndex={tabIndex ?? 1}
        autoFocus={autoFocus}
        onKeyDown={onKeyDown}
      />
      {searchIcon && <i className="pi pi-search" />}

      {/* </div> */}
      {touched && isError && <p className={styles.errorMsg}>{errorMessage}</p>}
    </div>
  );
};

export default NumberInput;
